<div class="mb-4 mt-4">
  <div class="flex justify-between">
    <div>
      <bl-frontend-button
        density="slim"
        variant="tonal"
        [trailingIcon]="{ name: 'sync' }"
        [disabled]="!client"
        (click)="loadFiles.emit()">
      </bl-frontend-button>
      <span class="mx-2"><span class="font-bold">Sökväg:</span> {{ currentPath }}</span>
      <bl-frontend-button
        density="slim"
        variant="tonal"
        [trailingIcon]="{ name: 'arrow-up' }"
        [disabled]="currentPath === '/'"
        (click)="upDir.emit()">
      </bl-frontend-button>
    </div>
    <bl-frontend-button
      [disabled]="sendingFiles"
      (click)="triggerFileUpload()"
      text="Välj fil(er) att ladda upp"></bl-frontend-button>
  </div>
</div>
<input
  type="file"
  #fileUpload
  id="fileUpload"
  name="fileUpload"
  multiple="multiple"
  accept="*/*"
  style="display: none"
  (change)="onFileSelectionChange($event)" />

<p-table
  [columns]="columns"
  [value]="files"
  [contextMenu]="cm"
  [(contextMenuSelection)]="selectedRowModel"
  [(selection)]="selectedRowModel"
  selectionMode="single"
  (onRowUnselect)="rowUnselect.emit($event)"
  [scrollable]="true"
  scrollHeight="flex"
  [style]="{ 'max-height': '550px' }"
  [tableStyle]="{ 'table-layout': 'fixed' }">
  <ng-template pTemplate="emptymessage" let-columns>
    <tr>
      <td [attr.colspan]="columns.length">
        <div class="my-3">
          {{ loading ? 'Laddar listan, vänligen vänta...' : 'Dra-och-släpp filer/mappar här för att spara i molnet' }}
        </div>
      </td>
    </tr>
  </ng-template>
  <ng-template pTemplate="header" let-columns>
    <tr>
      <th class="font-normal truncate" [pSortableColumn]="columns[0].field">
        {{ columns[0].header }}
        <p-sortIcon
          [field]="columns[0].field"
          ariaLabel="Activate to sort"
          ariaLabelDesc="Activate to sort in descending order"
          ariaLabelAsc="Activate to sort in ascending order">
        </p-sortIcon>
      </th>
      <th class="font-normal truncate" style="flex: 0 0 40px; width: 40px"></th>
    </tr>
  </ng-template>
  <ng-template pTemplate="body" let-rowData let-columns="columns">
    <tr [pSelectableRow]="rowData" (dblclick)="rowDblClick.emit(rowData)">
      <td [pContextMenuRow]="rowData">
        <i
          [class]="rowData.isFolder ? 'fa fa-folder' : 'far fa-file'"
          [style.color]="rowData.isFolder ? '#ffcc00' : ''"></i
        ><span class="ml-2"> {{ rowData.name }}</span>
      </td>
      <td style="flex: 0 0 40px; width: 40px">
        <span (click)="deleteFile.emit(rowData)" class="far fa-trash-alt" style="text-align: center; cursor: pointer">
        </span>
      </td>
    </tr>
  </ng-template>
</p-table>

<table class="mt-3">
  <tr>
    <td>
      <input type="text" class="form-control input-sm" [(ngModel)]="directoryModel" placeholder="Namn på ny mapp..." />
    </td>
    <td style="padding-left: 10px">
      <bl-frontend-button (click)="createDir.emit()" [disabled]="!directoryModel" text="Skapa"></bl-frontend-button>
    </td>
    <td style="padding-left: 10px"></td>
  </tr>
</table>

<p-contextMenu #cm appendTo="body" [model]="contextMenuItems"></p-contextMenu>

<p-dialog header="Ta bort fil/mapp?" [(visible)]="displayDeleteFileModel" showEffect="fade" [draggable]="false">
  <p>{{ pendingDeletionDocument.name }} kommer tas bort permanent.</p>
  <p>Vill du fortsätta?</p>
  <p-footer>
    <bl-frontend-button variant="secondary-negative" (click)="afterDeleteDialog.emit(false)" text="Nej"></bl-frontend-button>
    <bl-frontend-button (click)="afterDeleteDialog.emit(true)" text="Ja"></bl-frontend-button>
  </p-footer>
</p-dialog>

<p-dialog
  header="Byt namn på fil/mapp?"
  [(visible)]="displayRenameDialogModel"
  showEffect="fade"
  [style]="{ width: '400px' }"
  [draggable]="false">
  <input type="text" class="form-control input-sm" [(ngModel)]="pendingRenameDocument.newName" />
  <p-footer>
    <bl-frontend-button variant="secondary" (click)="afterRenameDialog.emit(false)" text="Avbryt"></bl-frontend-button>
    <bl-frontend-button (click)="afterRenameDialog.emit(true)" text="Spara"></bl-frontend-button>
  </p-footer>
</p-dialog>
